import { render, staticRenderFns } from "./certificatesMine.vue?vue&type=template&id=3efe653e&scoped=true"
import script from "./certificatesMine.vue?vue&type=script&lang=js"
export * from "./certificatesMine.vue?vue&type=script&lang=js"
import style0 from "./certificatesMine.vue?vue&type=style&index=0&id=3efe653e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe653e",
  null
  
)

export default component.exports